class Elementor_Events {
    static instance;

    static getInstance() {
        if (!Elementor_Events.instance) {
            Elementor_Events.instance = new Elementor_Events();
        }
        return Elementor_Events.instance;
    }

    constructor() {
        $(window).on('elementor/frontend/init', () => {
            this.init();
        });
    }

    init() {
        elementorFrontend.hooks.addAction('frontend/element_ready/opal-events.default', ($scope) => {
            let $carousel = $scope.find('.owl-carousel');
            if ($carousel.length > 0) {
                let data = $carousel.data('settings');
                $carousel.owlCarousel(Elementor_Carousel.setupData(data));
            }
        });
    }
}

Elementor_Events.getInstance();